import { getStore } from '~/mobx/AppStore';

const getIsLoggedIn = () => {
    const { userStore } = getStore();
    return userStore.user !== null && userStore.user !== undefined;
};

export default getIsLoggedIn;
